import { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Grid, Stack } from '@mui/material';

import Header from './header/Header';
import SubMenu from './sub-menu/SubMenu';
import Footer from './footer/Footer';

import common from '../components/app/App.module.scss';

import { BASE_URL, useGetAuthenticationQuery } from '../services/ADapi';

import AuthContext from '../contexts/authContext';
import NotFound from './not-found/NotFound';

const ProtectedRoutes = () => {
  const { planFeatures } = useContext(AuthContext);
  const { data = {}, isLoading } = useGetAuthenticationQuery();

  const isAuthenticated = data.is_authenticated;

  const { areAgentsActiveDirectoryAvailable, areNetsAgentsAvailable } =
    planFeatures;

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      window.location.href = `${BASE_URL}/auth/signin/`;
    }
  }, [isAuthenticated, isLoading]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Grid item className={common['app-right-column']}>
      <Stack sx={{ height: '100%' }}>
        <Header />
        {areAgentsActiveDirectoryAvailable || areNetsAgentsAvailable ? (
          <Stack className={common['wrapper']}>
            <SubMenu />
            <Outlet />
            <Footer />
          </Stack>
        ) : (
          <NotFound />
        )}
      </Stack>
    </Grid>
  );
};

export { ProtectedRoutes };
